<template>
  <v-card>
    <v-card-actions>
      <v-row>
        <v-col cols="12" md="4">
          <v-select dense outlined hide-details :label="$t('company')" :items="companiesList" item-value="company" item-text="asgn_shrt_nm" v-model="retrieveData.company" @change="companies_onChanged()"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select dense outlined hide-details :label="$t('businessunit')" :items="buList" item-value="bsns_cd" item-text="asgn_shrt_nm" v-model="retrieveData.bsns_cd" @change="bu_onChanged()"></v-select>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-text class="py-0 text-right">
      <v-btn @click="addSelectedItem()" small>선택</v-btn>
    </v-card-text>
    <v-card-text>
      <realgrid
        ref="deptGrid"
        :options="grid.gridOption"
        :fields="grid.gridFields"
        :columns="grid.gridColumns"
        :retrieveData="retrieveData"
        :retrieveApi="retrieveGrid"
        :height="grid.height"
      ></realgrid>
    </v-card-text>
  </v-card>
</template>

<script>
import Realgrid from '@/components/grid/Realgrid'
import {
  getBusinessUnits,
  getDepartments,
  getCompanies
} from '@/api/common/organizations'
import { getScrollOption } from '@/utils/scroll'
require('@/assets/theme/proton/style.min.css')

export default {
  name: 'Organization',
  components: {
    Realgrid
  },
  props: {
    value: {
      company: String,
      asgn_cd: String,
      bsns_cd: String,
      default: ''
    },
    selected: Function
  },
  data() {
    return {
      retrieveData: {
        company: '',
        bsns_cd: ''
      },
      companiesList: [], // companies
      buList: [], // 사업부
      grid: {
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: false,
              insertable: false,
              deletable: false
            },
            checkBar: {
              // 체크바 숨김
              visible: false
            },
            panel: {
              visible: false
            },
            stateBar: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: [],
        height: 250
      },
      // 트리 스크롤 스타일
      treeOps: {}
    }
  },
  created() {
    this.scrollOps()
    this.initGrid()
  },
  mounted() {
    Promise.all([getCompanies()]).then(responses => {
      // 1. 시스템 리스트
      this.companiesList = responses[0]
      this.retrieveData.company = this.companiesList[0].company
      this.companies_onChanged()
    })
  },
  computed: {
    retrieveGrid() {
      // 그리드 데이터 조회
      return getDepartments
    }
  },
  methods: {
    scrollOps() {
      this.treeOps = getScrollOption()
    },
    initGrid() {
      // 그리드 필드
      this.grid.gridFields = [
        { fieldName: 'asgn_cd', dataType: 'string' },
        { fieldName: 'asgn_full_nm', dataType: 'string' },
        { fieldName: 'company', dataType: 'string' },
        { fieldName: 'asgn_shrt_nm', dataType: 'string' }
      ]
      // 그리드 컬럼
      this.grid.gridColumns = [
        {
          name: 'asgn_cd',
          fieldName: 'asgn_cd',
          header: {
            text: '부서코드'
          },
          width: 100,
          textAlignment: 'center',
          visible: true
        },
        {
          name: 'asgn_shrt_nm',
          fieldName: 'asgn_shrt_nm',
          header: {
            text: '부서명'
          },
          width: 400,
          visible: true
        },
        {
          name: 'asgn_full_nm',
          fieldName: 'asgn_full_nm',
          header: {
            text: 'Full Name'
          },
          width: 100,
          visible: false
        },
        {
          name: 'company',
          fieldName: 'company',
          header: {
            text: '회사'
          },
          width: 200,
          visible: true
        }

      ]
    },
    companies_onChanged() {
      getBusinessUnits(this.retrieveData).then(responses => {
        this.buList = responses
        this.retrieveData.bsns_cd = this.buList[0].bsns_cd
        this.bu_onChanged()
      })
    },
    bu_onChanged() {
      this.$refs.deptGrid.retrieve()
    },
    addSelectedItem() {
      let current = this.$refs.deptGrid.getGridView().getCurrent()
      var jsonData = this.$refs.deptGrid.getDataProvider().getJsonRow(current.dataRow)
      this.selected(jsonData)
    }
  },
  beforeDestroy() {
    this.jstreeObj.jstree(true).destroy()
  }
}
</script>

<style scoped>

</style>
